import React from "react";
import { Box, Group, Badge, UnstyledButton } from "@mantine/core";
import { Employee } from "../../types/salon";
import { StaffIdentity } from "../common/StaffIdentity";
import styles from "./StaffCard.module.css";

interface StaffCardProps {
  employee: Employee;
  onEdit: (e: React.MouseEvent, employee: Employee) => void;
  currentUser?: Employee | null;
  canEdit?: boolean;
}

export default function StaffCard({
  employee,
  onEdit,
  currentUser,
  canEdit = true,
}: StaffCardProps) {
  const isInactive = employee.status === "Inactive";

  return (
    <Box key={employee.id} className={styles.card}>
      <Group justify="space-between" gap={14} wrap="nowrap">
        <StaffIdentity
          firstName={employee.first_name}
          lastName={employee.last_name}
          role={employee.role}
          title={employee.title}
          photoUrl={employee.staff_photo_url ?? employee.avatar_url}
          inactive={isInactive}
          trailing={
            employee.has_bookable_calendar === false && (
              <Badge size="xs" color="gray" variant="light">
                No calendar
              </Badge>
            )
          }
        />
        {canEdit &&
          (employee?.role !== "Owner" || currentUser?.role === "Owner") && (
            <UnstyledButton
              className={styles.editButton}
              onClick={(e) => onEdit(e, employee)}
            >
              Edit
            </UnstyledButton>
          )}
      </Group>
    </Box>
  );
}
